import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { getToken, removeToken } from "../utils/auth";
import ApiEndpoints from "./apiEndPoints";

// Create base query instance
const createBaseQuery = fetchBaseQuery({
  baseUrl: ApiEndpoints.baseApiURL,
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) headers.set("authorization", `Bearer ${token}`);
    headers.set("content-type", "application/json");
    return headers;
  },
});

export const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await createBaseQuery(args, api, extraOptions);

  // Handle 401 Unauthorized
  if (result.error && result.error.status === 401) {
    // Clear authentication data
    removeToken();
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to login, include the page we came from
    // const from = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    // window.location.href = `/login?from=${encodeURIComponent(from)}`;
  }

  return result;
};
